/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { tryParseJson } from 'src/core/utils/base';
import { LuisConstants } from 'src/core/utils/LuisConstants';

type AllowlistFeatures = 'questionGeneration' | 'documentTranslationTool';
export type Allowlist = { feature: AllowlistFeatures; resources: string[]; subscriptions: string[] };

export const getAzureAppConfigAllowlist = () =>
    tryParseJson<Allowlist[]>(window.allowlist) ?? [
        {
            feature: 'questionGeneration',
            resources: LuisConstants.QnaMaker.whitelistedResources,
            subscriptions: []
        },
        {
            feature: 'documentTranslationTool',
            resources: [],
            subscriptions: LuisConstants.TranslationTool.whitelistedSubscriptionIds
        }
    ];
